(function(){
    'use strict'

    angular
    .module('app.areas')
    .controller('Areas', Areas);

    Areas.$inject = ['$animationsSrv', 'AreasService', 'logger', '$location', 'UserInfoService'];

    function Areas($animationsSrv, AreasService, logger, $location, UserInfoService) {
    
        $animationsSrv.scrollToTop();
        
        var vm = this;

        vm.areas = [];
        vm.title = 'Areas';

        vm.goToEdit = function(area){
            
            var path = '/editar-area/';

            if(area){
                $location.path(path + area.id);
            }
            else{
                $location.path(path);
            }
            
        };

        vm.openModal = function(modalName){
            $(modalName).modal('toggle');    
        };

        getAll();

        function getAll(){

            var promise = AreasService.getAll(UserInfoService.getCompaniaId());

            promise
            .then(function(areas){
                vm.areas = areas;
            })
            .catch(function(error){
                switch (error.status) {
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                
                    default:
                        logger.error('Error al obtener los areas.');
                        break;
                }
            });
        };

        vm.delete = function(area){
            var promise = AreasService.remove(area);
            
            promise
            .then(function(response){
                vm.areas = vm.areas.filter(function(g) {
                    return g.id !== area.id;
                });
                logger.success('Area eliminado con éxito.');
            })
            .catch(function(error){
                switch (error.status) {
                    case 500:
                        logger.error(error.data.Message);
                        break;
                    case 401:
                        logger.error('La sessión ha terminado.');
                        break;
                    default:
                        logger.error('Hubo un erro al eliminar el Area');
                        break;
                }
                
            });   
        };

    }
})();